import classNames from 'classnames';

type Props = {
    children: React.ReactNode;
    onClick?: () => void;
    className?: string;
}

export const Chip: React.FC<Props> = ({children, className, onClick}: Props) => (
    <div
        className={classNames(`tw-m-2 md:tw-py-2 md:tw-px-3 md:tw-border
                   tw-rounded-3xl tw-text-nowrap -md:tw-px-2`, className, {
            'tw-border-default': !onClick,
            'tw-cursor-pointer tw-border-primary tw-text-primary': !!onClick
        })}
        onClick={onClick}
    >
        {children}
    </div>
);